

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { LayoutModule } from '@angular/cdk/layout';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatExpansionModule } from '@angular/material/expansion';

import { MatFieldComponent } from '../_shared/components/mat-field/mat-field.component';
import { DrawerComponent } from '../_shared/components/drawer/drawer.component';
import { ApiService, QuestionnaireService, ProgramStatusService } from '@ebb-v2/ebb-integration';


@NgModule({ declarations: [
        MatFieldComponent,
        DrawerComponent
    ],
    exports: [
        LayoutModule,
        ReactiveFormsModule,
        MatCardModule,
        MatButtonModule,
        MatListModule,
        MatDividerModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonToggleModule,
        MatFieldComponent,
        DrawerComponent,
        MatSidenavModule,
        HttpClientModule,
        MatDialogModule,
        MatProgressSpinnerModule
    ], imports: [CommonModule,
        ReactiveFormsModule,
        LayoutModule,
        MatCardModule,
        MatButtonModule,
        MatListModule,
        MatDividerModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonToggleModule,
        MatSidenavModule,
        HttpClientModule,
        MatDialogModule,
        MatProgressSpinnerModule], providers: [
        ApiService,
        QuestionnaireService,
        ProgramStatusService, MatFieldComponent,
        DrawerComponent
        
    ] })
export class SharedModule { }
